import { themeUi } from '../../themeUi/themeUi';

const pagesTitle = {
  color: themeUi.semantic.color.text.neutral800
};

export default pagesTitle;
